'use strict';

function getSortOrderIndex(chr, sortOrder) {
  if (!chr) {
    return null;
  } else {
    return sortOrder.indexOf(chr);
  }
}

module.exports = getSortOrderIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/internal/getSortOrderIndex.js
// module id = 401
// module chunks = 0